export default __webpack_public_path__ + "a02b2c38991e85a01779f92bce22663e.png";